function EmoteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <g
        stroke="#666"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        clipPath="url(#clip0_384_2272)"
      >
        <path d="M8 14.737A6.667 6.667 0 108 1.403a6.667 6.667 0 000 13.334z"></path>
        <path d="M5.333 9.403s1 1.334 2.667 1.334c1.667 0 2.667-1.334 2.667-1.334M6 6.07h.016M10 6.07h.016"></path>
      </g>
      <defs>
        <clipPath id="clip0_384_2272">
          <path
            fill="#fff"
            d="M0 0H16V16H0z"
            transform="translate(0 .07)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default EmoteIcon;